 <!-- 马经理要求根目录---解决woker.js报错问题 -->
<style src="./annotationLayer.css"></style>
<script>
  import PdfjsWorker from 'pdfjs-dist/build/pdf.worker.js'
  import componentFactory from './componentFactory.js'

  if ( process.env.VUE_ENV !== 'server' ) {

    var pdfjsWrapper = require('./pdfjsWrapper.js').default;
    var PDFJS = require('pdfjs-dist/build/pdf.js');

    if ( typeof window !== 'undefined' && 'Worker' in window && navigator.appVersion.indexOf('MSIE 10') === -1 ) {
      PDFJS.GlobalWorkerOptions.workerPort = new PdfjsWorker();
    }

    var component = componentFactory(pdfjsWrapper(PDFJS));
  } else {

    var component = componentFactory({});
  }

  export default component;
</script>